module.exports = __webpack_public_path__ + "static/media/Chair_Character.e9637eb7.jpg";